import { HTMLAttributes } from "react";

import { Heading2 } from "@/ui2/atoms/Heading";

export function SignatureField({
  children,
  label,
  ...rest
}: HTMLAttributes<HTMLLIElement> & { label: string }) {
  return (
    <li className="tw:flex tw:flex-col" {...rest}>
      <Heading2 as="h4" size={1}>
        {label}
      </Heading2>

      {children}
    </li>
  );
}
